export interface CategoryMeta {
  label: string;
  /** Symbol id in the Home icon sprite. */
  icon: string;
  tint: string;
  /** Three-stop palette for the generated poster art. */
  palette: [string, string, string];
}

const META: Record<string, CategoryMeta> = {
  concert: { label: 'Concerts', icon: 'i-music', tint: 'rgba(229,9,20,.32)', palette: ['#2a0306', '#e50914', '#0c0c10'] },
  festival: { label: 'Festivals', icon: 'i-tent', tint: 'rgba(251,146,60,.30)', palette: ['#3a0a05', '#ff7a18', '#120404'] },
  theatre: { label: 'Theatre', icon: 'i-mask', tint: 'rgba(168,85,247,.28)', palette: ['#1a0a2a', '#a855f7', '#08040f'] },
  family: { label: 'Family', icon: 'i-users', tint: 'rgba(45,212,191,.26)', palette: ['#04212a', '#14b8a6', '#050b10'] },
  comedy: { label: 'Comedy', icon: 'i-mic', tint: 'rgba(250,204,21,.24)', palette: ['#2a2003', '#facc15', '#0e0b02'] },
  sports: { label: 'Sports', icon: 'i-trophy', tint: 'rgba(110,231,183,.26)', palette: ['#03261c', '#34d399', '#03100b'] },
  other: { label: 'Other', icon: 'i-ticket', tint: 'rgba(229,9,20,.25)', palette: ['#2b0620', '#ff4fa3', '#0d0510'] },
};

const ALIASES: Record<string, string> = {
  theater: 'theatre',
};

const titleCase = (s: string) => s.replace(/[-_]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export function categoryMeta(slug: string): CategoryMeta {
  const key = ALIASES[slug?.toLowerCase()] ?? slug?.toLowerCase();
  return META[key] ?? { ...META.other, label: titleCase(slug || 'Events') };
}

/** Count occurrences and return `[value, count]` pairs, most frequent first. */
export function tally(values: string[]): Array<[string, number]> {
  const counts = new Map<string, number>();
  values.forEach((v) => {
    if (v) counts.set(v, (counts.get(v) ?? 0) + 1);
  });
  return Array.from(counts.entries()).sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]));
}
